module.exports = __webpack_public_path__ + "img/V5heightLight.cc091776.png";